import request from '@/config/axios'

// 招标平台 VO
export interface BidPlatformVO {
  id?: number // 编号
  feeStandard?: number // 收费标准（字典 crm_bid_platform_fee_standard）
  type?: number // 类型（字典 crm_bid_platform_type）
  name?: string // 平台名称
  website?: string // 网址
  thirdPartyEvaluation?: string // 第三方评价
  trafficAnalysis?: string // 站长工具统计具体的平台流量分析
  accountPassword?: string // 账号/密码
  cooperationStatus?: number // 合作状态（字典 crm_bid_platform_cooperation_status）
  feeDesc?: string // 费用说明
  remark?: string // 备注
  createTime?: Date // 创建时间
}

// 招标平台 API
export const BidPlatformApi = {
  // 查询招标平台分页
  getBidPlatformPage: async (params: any) => {
    return await request.get({ url: `/crm/bid-platform/page`, params })
  },

  // 查询招标平台详情
  getBidPlatform: async (id: number) => {
    return await request.get({ url: `/crm/bid-platform/get?id=` + id })
  },

  // 新增招标平台
  createBidPlatform: async (data: BidPlatformVO) => {
    return await request.post({ url: `/crm/bid-platform/create`, data })
  },

  // 修改招标平台
  updateBidPlatform: async (data: BidPlatformVO) => {
    return await request.put({ url: `/crm/bid-platform/update`, data })
  },

  // 删除招标平台
  deleteBidPlatform: async (id: number) => {
    return await request.delete({ url: `/crm/bid-platform/delete?id=` + id })
  },

  // 导出招标平台
  exportBidPlatform: async (params: any) => {
    return await request.download({ url: `/crm/bid-platform/export`, params })
  },

  // 下载招标平台导入模板
  getBidPlatformImportTemplate: async () => {
    return await request.download({ url: `/crm/bid-platform/get-import-template` })
  },

  // 导入招标平台
  importBidPlatform: async (data: any, updateSupport: boolean) => {
    return await request.upload({
      url: `/crm/bid-platform/import`,
      params: { updateSupport },
      data
    })
  }
}
